import styled from "styled-components"

export default styled.section`
  width: 100%;
  padding-top: 50px;

  .move__box-button {
      margin-top: 20px;
  }

  .move__box-select {
      max-width: 240px;
  }

  .move__box-select {
      @media (max-width: 1900px) {  
          max-width: 160px;
      }
      @media (max-width: 1700px) {
          max-width: 140px;
      }
      @media (max-width: 1600px) {
          max-width: 130px;
      }
      @media (max-width: 1599px) {
          max-width: 110px;
      }
      @media (max-width: 1400px) {
          max-width: 100px;
      }
      @media (max-width: 1340px) {
          max-width: 77%;
      }
  }

  .move__box-label {
      margin-right: 20px;
      text-transform: none;
  }

  .move-modal-content {
      justify-content: center;
  }

  .copy-products {
      background-color: #4646ff;
  }

  .select2-single {
      max-width: 100%;
      width: 100%;
  }

  .select2-single .react-select__control {
      max-width: 100%;
      min-width: 200px;
  }

  .select2-single .react-select__single-value,
  .select2-single .react-select__input-container {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
  }

  .select2-single .react-select__menu {
      max-width: 100%;
      width: 100%;
  }
`